import React from 'react';
import { cn } from '../lib/utils';
import { StatusBadge, type StatusBadgeProps } from './status-badge';

export interface ChecklistItem {
  id: string;
  name: string;
  status: StatusBadgeProps['status'];
  statusTone?: StatusBadgeProps['tone'];
  reason?: React.ReactNode;
  action?: React.ReactNode;
}

export interface ChecklistListProps {
  items: ChecklistItem[];
  label?: string;
  className?: string;
}

export function ChecklistList({ items, label = 'Checklist', className }: ChecklistListProps) {
  return (
    <ul
      aria-label={label}
      className={cn('w-full min-w-0 divide-y divide-border font-body text-body', className)}
    >
      {items.map((item) => (
        <li
          key={item.id}
          className="flex w-full min-w-0 flex-col gap-4 py-4 sm:flex-row sm:flex-wrap sm:items-start"
        >
          <div className="min-w-0 flex-1 space-y-1 sm:min-w-[20ch]">
            <div className="flex min-w-0 flex-wrap items-start gap-2">
              <span className="min-w-0 break-words font-medium text-text-heading [overflow-wrap:anywhere]">
                {item.name}
              </span>
              <StatusBadge status={item.status} tone={item.statusTone} size="sm" />
            </div>
            {item.reason != null && (
              <div className="min-w-0 break-words text-caption font-normal text-text-muted [overflow-wrap:anywhere]">
                {item.reason}
              </div>
            )}
          </div>
          {item.action != null && (
            <div className="w-full min-w-0 max-w-full [&>*]:max-w-full sm:w-auto">
              {item.action}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
